<!--suppress UnnecessaryLabelJS -->
<template>
	<v-data-table
		:headers="headers"
		:items="updates"
		:loading="loading"
		class="elevation-1"
	>
		<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
		<template #item="{item}">
			<update-row :key="item.id" @edit="onEdit" :update="item"/>
		</template>
	</v-data-table>
</template>

<script>
	import UpdateRow from "src/view/updates/UpdateRow";
	import {types} from "src/store/modules/Update.module";
	import FilterAble from "src/mixins/FilterAble";

	export default {
		name: "updates-table",
		props: [],
		components: {
			UpdateRow
		},
		mixins: [new FilterAble(types)],
		data() {
			return {
				loading: false,
				headers: [
					{text: "תוכן העדכון", value: "content"},
					{text: "תאריך לעזי", value: "created_at"},
					{text: "תאריך עברי", value: "heb_date"},
					{text: "תמונה", value: "img"},
					{text: "חדשות רצות/ חדשות עם תמונה", value: "type"},
					{text: "מוצג/ לא מוצג", value: "active"},
				],
				search: null,
				showDialog: false
			};
		},
		computed: {
			updates() {
				return this.$store.state.UpdateModule.updates;
			}
		},
		methods: {
			onEdit(Update) {
				this.$emit("edit", Update);
			}
		}
	};
</script>

<style>

</style>
